let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Bq2e")).then(() => parcelRequire('ekh6j'));